import { createContext } from 'react';

const AccountContext = createContext<string>('');
export {
  AccountContext
};
